import {Box} from "@mui/material";
import React, { useEffect, useState } from "react";
import localforage from "localforage";

/**
 * Xpi component
 *
 * This component renders a Box from MUI with optional slot properties.
 * It displays the Greek letter pi (π) in the bottom right corner if the `pi` variable is defined and has a length greater than 0.
 * Clicking on the pi symbol while holding the Meta and Shift keys toggles a boolean value in localStorage.
 *
 * @param {Object} props - Component props
 * @param {string} props.keyname - Name of the localStorage key
 * @param {Object} props.slotProps - Additional slot properties
 */

const Xpi = ({keyname, onClick, slotProps}) => {
	const [feedback, setFeedback] = useState(null);

	useEffect(() => {
		console.log("Xpi - key: ", keyname);
	}, []);

	return (
		<Box {...slotProps?.root}>
			{keyname && keyname.length > 0 && (
				<Box sx={{
					position: "absolute",
					bottom: 0,
					right: 0,
					p: 1,
					cursor: "pointer",
					color: "#dad3d3",
					"&:hover": {
						color: "#a0a0a0"
					},
					...slotProps?.label?.sx
				}}
						 onClick={async(e) => {
							 if (e.metaKey && e.shiftKey || e.ctrlKey && e.shiftKey) {
								 const et = await localforage.getItem(keyname) === "true";
								 await localforage.setItem(keyname, et ? "false" : "true");

								 setFeedback(`${keyname} ${(et ? "Inactive" : "Active")}`);
								 setTimeout(() => setFeedback(null), 2000);
								 if (onClick) {
									 onClick();
								 }
							 }
						 }}
						 {...slotProps}
				>
					{feedback && feedback.length > 0 && (
						<Box
							sx={{
								position: "absolute",
								bottom: 30, // Adjust as needed
								right: 0,
								backgroundColor: "rgba(0, 0, 0, 0.7)",
								color: "#fff",
								p: 1,
								borderRadius: 1
							}}
						>
							{feedback}
						</Box>
					)}
					{"\u03C0"}

				</Box>
			)}
		</Box>
	);
};
export default Xpi;
